import { useQueryClient } from '@tanstack/react-query';
import { useReleaseOnCartEmpty } from '@hooks/useReleaseOnCartEmpty';
import { useShoppingCart } from '@hooks/useShoppingCart/useShoppingCart';
import { useCheckoutStore } from '@store/checkoutStore';

type UseEmptyCartOptions = {
  onError?: (error: Error) => void;
};

export const useEmptyCart = (sessionId: string, options?: UseEmptyCartOptions) => {
  const queryClient = useQueryClient();
  const { cart, isCartLoading, removeAllItems } = useShoppingCart(sessionId, { onError: options?.onError });

  const { releaseIfCartEmpty } = useReleaseOnCartEmpty();
  const resetCheckout = useCheckoutStore((s) => s.reset);

  const emptyCart = async (): Promise<void> => {
    await queryClient.cancelQueries();
    releaseIfCartEmpty(cart ? { ...cart, cartItem: [] } : null);
    removeAllItems();
    resetCheckout();
  };

  return { emptyCart, isCartLoading };
};
